import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {storesTableReady,rowsPerPageState,searchTextState,paginationState,storesIdForAction,addEditStoreKitchenDataForAction,addEditStoreIdForAction} from '../redux/stores'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/storeTable.css'
import CollapsibleRow from './CollapsibleRow'


import * as Helpers from '../../../common/helpers'


import { CSVLink } from 'react-csv'
import { createStoreXLSheetdata } from '../services/helpers'


import moment from 'moment'


function filterExportData(storesData) {

    
    let newArray = []
    if (storesData.length > 0) {
        for (let i = 0; i < storesData.length; i++) {

            if(storesData[i].store_timings.length>0){
                for (let j = 0; j < storesData[i].store_timings.length; j++) {
                    let newLineData = {}
                    let lineData = storesData[i]
                    newLineData.id = lineData.id;
                    newLineData.store_name = lineData.store_name
                    newLineData.status = lineData.status
                    newLineData.kitchen_name = lineData.kitchen_name
                    newLineData.brand_name = lineData.brand_name
                    newLineData.kitchen_code=lineData.kitchen_code
                    newLineData.city_name=lineData.city_name
                    newLineData.business_status=lineData.business_status
                    newLineData.business_remarks=lineData.business_remarks
                    newLineData.store_platforms=lineData.store_platforms
                    newLineData.urbanpiper_id = lineData.urbanpiper_id
                    newLineData.start_time = lineData.store_timings[j].start_time
                    newLineData.end_time = lineData.store_timings[j].end_time
                    newLineData.end_day = lineData.store_timings[j].end_day  
                    newArray.push(newLineData)       
                }
            }else{
                    let newLineData = {}
                    let lineData = storesData[i]
                    newLineData.id = lineData.id
                    newLineData.kitchen_code=lineData.kitchen_code
                    newLineData.city_name=lineData.city_name
                    newLineData.store_name = lineData.store_name
                    newLineData.status = lineData.status
                    newLineData.business_status=lineData.business_status
                    newLineData.business_remarks=lineData.business_remarks
                    newLineData.kitchen_name = lineData.kitchen_name
                    newLineData.brand_name = lineData.brand_name
                    newLineData.urbanpiper_id = lineData.urbanpiper_id  
                    newLineData.store_platforms=lineData.store_platforms
                    newArray.push(newLineData)     
            
            }

        }
    }
    return newArray
}





function filterUnwantedData(storesData) {
    let array = []
    if (storesData && storesData.data && storesData.data.list) {
        array = storesData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.store_name = lineData.name ? lineData.name : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"
            newLineData.kitchen_name =lineData.kitchen.name ? lineData.kitchen.name : "NA"
            newLineData.kitchen_code=lineData.kitchen.code ? lineData.kitchen.code : "NA"
            newLineData.brand_name =lineData.brand.name ? lineData.brand.name : "NA"
            newLineData.urbanpiper_id =lineData.urbanpiper_id ? lineData.urbanpiper_id : "NA"


            newLineData.business_status =lineData.business_status ? lineData.business_status : ""
            newLineData.business_remarks =lineData.business_remarks ? lineData.business_remarks : ""

            

            newLineData.city_name = lineData.kitchen && lineData.kitchen.city && lineData.kitchen.city.name ? lineData.kitchen.city.name : ""


            newLineData.store_platforms=""
             let temp = [];
                if(lineData.store_platforms.length>0){                    
                    for (var k = 0; k < lineData.store_platforms.length; k++) {                        
                        temp[k]=lineData.store_platforms && lineData.store_platforms[k].platform && lineData.store_platforms[k].platform.name ? lineData.store_platforms[k].platform.name: ""
                        
                    }
                }

                newLineData.store_platforms=temp.join(", ");

            let store_timings = []
            
            for (let j = 0; j < lineData.store_timings.length; j++) {
                let end_day=false;
                if(lineData.store_timings[j].end_day==="NEXT_DAY"){
                    end_day=true;
                }

                store_timings[j]={
                    "store_timings_id":lineData.store_timings[j].id,
                    "store_id":lineData.id,
                    "start_time":lineData.store_timings[j].start_time,
                    "end_time":lineData.store_timings[j].end_time,
                    "end_day":end_day
                    }                    
            }   
            newLineData.store_timings=store_timings;


            newArray[i] = newLineData
        }
    }
    return newArray
}


class StoresTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            storesData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null


        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(storesTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.STORES_TABLE)) 
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getStoresData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getStoresData = () => {
        apiService.getStoresData()
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.stores && this.props.stores.previousPaginationValue) {
                            pageNo = this.props.stores.previousPaginationValue
                        }
                        this.setState({
                            storesData: array,
                            page: pageNo,
                        })

                        let exportData=filterExportData(array)

                        this.createCSVData(exportData)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(storesTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(storesTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }


     createCSVData(csvData) {
        let storeList = []
        if (csvData) {
            storeList = JSON.parse(JSON.stringify(csvData))
            storeList = createStoreXLSheetdata(storeList)
        }
        this.CSVData = storeList
    }



    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.stores && this.props.stores.previousRowsPerPageValue) {
            value = this.props.stores.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }


     renderBuisnessStatus = (cell, row, enumObject, rowIndex) => {
        //debugger;
        

        let business_status=""


        business_status = <p>{row.business_status}<br/>[ {row.business_remarks} ]</p>


        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{business_status} </div>
        </div>)


         }



     addBtnCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        

        let addBtn=""
        let editBtn=""


    if(Helpers.checkPrivileges("/dashboard/stores/addEditTiming",this.props.user)){

        addBtn =<button
            className="action-button"
            style={{marginBottom: "1px" }}
            onClick={(e) => {
                e.preventDefault()
                this.addTimingFn(row)
            }}>
            <i className="fa fa-clock-o" aria-hidden="true"></i> Add Timing
        </button>
         
         }







 if(Helpers.checkPrivileges("/dashboard/stores/addEdit",this.props.user)){


        editBtn =<button
            className="action-button"
            style={{marginBottom: "1px",background: "#f0b209" }}
            onClick={(e) => {
                e.preventDefault()
                this.ediStoreFn(row)
            }}>
            <i className="fa fa-pencil-square" aria-hidden="true"></i> Edit Store
        </button>

    }



        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{addBtn} {editBtn}</div>
        </div>)
    }

addTimingFn= (row) =>{

    if (row && row.id) {
            this.props.dispatch(storesIdForAction(row.id))
            this.props.history.push("/dashboard/stores/addEditTiming")
        } else {
            this.dialog.show({
                title: "Store Identification number not found",
                body: 'Store id is not available, So not able edit store',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    
}

 ediStoreFn= (row) =>{

        if (row && row.id) {
                
            this.props.dispatch(addEditStoreIdForAction(row.id))
            this.props.dispatch(addEditStoreKitchenDataForAction())
                this.props.history.push("/dashboard/stores/addEdit")
            } else {
                this.dialog.show({
                    title: "Store Identification number not found",
                    body: 'Store id is not available, So not able edit store',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            }
        
    }





   

    createCustomToolBar = props => {


        let storesDetailsFilename = "stores_data_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                    {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/stores/list",this.props.user)){
                    return(

                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                    


                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={storesDetailsFilename}>
                            Export
                        </CSVLink>
                    </div>
                    )
                }
            })()}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    
    
    
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.storesData.length>=(this.props.stores.previousPaginationValue*this.props.stores.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.stores.previousPaginationValue*this.props.stores.previousRowsPerPageValue)-this.props.stores.previousRowsPerPageValue+1} to {this.props.stores.previousPaginationValue*this.props.stores.previousRowsPerPageValue} of {this.state.storesData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.stores.previousPaginationValue*this.props.stores.previousRowsPerPageValue)-this.props.stores.previousRowsPerPageValue+1} to {this.state.storesData.length} of {this.state.storesData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredStoreList = () => {
       
        this.props.dispatch(storesTableReady(false))
        this.resetSearchAndPagination()
        this.getStoresData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }


    expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <CollapsibleRow row={row} row_id={row_id} getProductStocksData={this.getProductStocksData} />
    }

    isExpandableRow = row => {
        return true
    }

    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }


    
    resetFilterValues = () => {
        this.resetPagination()
        this.getStoresData()
        this.props.dispatch(storesTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

  
     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.stores && this.props.stores.previousPaginationValue
            && this.props.stores.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editStore = (row) => {
        if (row && row.id) {
            this.props.dispatch(storesIdForAction(row.id))
            this.props.history.push("/dashboard/store/addedit")
        } else {
            this.dialog.show({
                title: "Store Identification number not found",
                body: 'Store id is not available, So not able edit store',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.stores && this.props.stores.previousRowsPerPageValue) {
            sizeperPage = this.props.stores.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
           sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (

            <div className="stores-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>                

                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.storesData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent,
                        columnWidth: 30
                    }}>

                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"                                            
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='left'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="store_name"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="kitchen_name"
                        
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="brand_name"
                        
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Brand
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="urbanpiper_id"
                        
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        UrbanPiper id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="status"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        //dataField=""
                         dataFormat={this.renderBuisnessStatus}
                         dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Business Status
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="store_platforms"
                        
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Platforms
                    </TableHeaderColumn>



                     <TableHeaderColumn
                          width="200"
                         expandable={false}
                        dataFormat={this.addBtnCreator}
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal', textAlign:'left'}}>
                        Actions
                    </TableHeaderColumn>  

                
                </BootstrapTable>
            </div>


        )



    }

}



const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        stores: state.stores
    }
}

export default connect(mapStateToProps)(withRouter(StoresTable))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/StoresTable.js